import axios from '../index'

export default {
        getPermisosSeccion (params) {
            return axios.get('/api/v1/personas/permisos', {
                params
            })
        },
        getInstituciones (params) {
            return axios.get('/instituciones/usuario/', {
                params
            })
        },
        ///ciclos-escolares/ciclosPorInstitucion/' + form.institucion_id
        getCiclosEscolares (institucionId, params = {}) {
            return axios.get('/ciclos-escolares/ciclosPorInstitucion/'+ institucionId, {
                params
            })
        },
        //ciclos-escolares/ciclosPorInstitucion/' + form.institucion_id
        getMetodosPagos (params = {}) {
            return axios.get('/api/v1/cobranza/listado/metodos-pagos-cfdi', {
                params
            })
        },
        // componentes-academicos/porInstitucionId/'+root.crnsModal.institucion_id
        getComponentesAcademicos (institucionId, params) {
            return axios.get('/componentes-academicos/porInstitucionId/'+ institucionId, {
                params
            })
        },
        //programas/institucion/'+root.crnsModal.institucion_id
        getProgramas (institucionId, params = {}) {
            return axios.get('/programas/institucion/' + institucionId, {
                    params
                })
        },
        getProgramasByNivel (institucionId, nivelId, params = {}) {
            return axios.get('/programas/institucion/' + institucionId + '/' + nivelId, {
                    params
            })
        },
        getPeriodo(institucionId){
            return axios.get('/ofertas/atributos/' + institucionId)
        },
        getInscribirMasivo(formData){
            return axios.post('/proceso-inscripcion/inscribir/masivo', formData)
        },
        //asignaturas/porPlanDeEstudiosId/'+ programaId
        getPlanEstudios (programaId, params = {}) {
            return axios.get('/planesEstudio/porProgramaId/' + programaId, {
                params
            })
        },
        getStatus () {
            return [
                { text:'Activo', id:'A' }, { text:'Inactivo', id:'I' } ,{ text:'Cancelado', id:'C' }
            ]
        },
        //asignaturas/porPlanDeEstudiosId/'+ programaId
        getAsignaturas (planId, params = {}) {
            return axios.get('/asignaturas/porPlanDeEstudiosId/' + planId, {
                params
            })
        },
        //edificios/porInstitucionId/{institucion_id}
        getEdificios (institucionId, params = {}) {
            return axios.get('/planta-fisica/edificios/porInstitucionId/' + institucionId, {
                params
            })
        },
        getAulas (edificioId, params = {}) {
            return axios.get('/planta-fisica/aula/porEdificioId/' + edificioId, {
                params
            })
        },
        getNivelesAcademicos (institucionId, params = {}) {
            return axios.get('/niveles-academicos/filtrar?institucion_id=' + institucionId, {
                params
            })
        },
        getDocentes (institucionId, params = {}) {
            return axios.get('/docentes/porInstitucionId/' + institucionId, {
                params
            })
        },
        // /grupos-administrativos/gruposInstitucion/'+ form.institucion_id + '?ciclo_escolar_id=' + form.ciclo_escolar_id
        getGruposAdmin (institucionId, params = {}) {
            return axios.get('/grupos-administrativos/gruposInstitucion/' + institucionId , {
                    params
            })
        },
        getBloquesListado (institucionId, params = {}) {
            return axios.get('/bloques-crns/catalogo/' + institucionId , {
                    params
            })
        },
        getDias () {
            return [
                { text:'Lunes', id:'l' },
                { text:'Martes', id:'m' } ,
                { text:'Miércoles', id:'mi' },
                { text:'Jueves', id:'j' },
                { text:'Viernes', id:'v' } ,
                { text:'Sabado', id:'s' },
                { text:'Domingo', id:'d' },
            ]
        },
        getDescuentos (params = {}) {
            return axios.get('/api/v1/cobranza/listado/descuentos', {
                params
            })
        },

        getInstitutosDefault (params = {}) {
            return axios.get('/api/v1/instituciones/directiva', {
                params
            })
        },

        getCicloDefault (params = {}) {
            return axios.get('/api/v1/ciclos-escolares/directiva',{
                params
            })
        },
        getCalificaciones(params){
            return axios.get('/alumno-calificaciones/getCalificacionesPorAlumno',{
                params
            })
        },
        getGrado(id){
            return axios.get('/programas/grados/' + id)
        },
        getActualizarCalif(formData){
            return axios.post('/alumno-calificaciones/correccionCalificacion', formData)
        },

        postAgregarCalificacion(formData){
            return axios.post('/alumno-calificaciones/registroCalificacion', formData)
        },

        getConciliar(params){
            return axios.get('/api/v1/conciliacion/banamex/aplicarPago', {params})
        },

        getEscalaCalificaciones(){
            return axios.get('/escala-de-calificaciones/getEscalasNumericas')
        },

        getExpepedienteDigital(params){
            return axios.get('/expedienteDigital/getDocumentosPorPersona', {params})
        },
        postExpedienteDigital(formData){
            return axios.post('/expediente-digital/cargar-archivo/{documento_id}/{persona_id}', formData)
        },
        postClonarCodigosSesion(params){
            return axios.post('/crns/cloneCrnsByInstitutionAndCicloEscolar', params)
        },
        getObservaciones(params){
            return axios.get('/docente-observaciones/getObservacionesPorAlumno', {params})
        }

}
